import { StudentAssessmentReportData } from '@protos/learning_management/lms.assessment.student.apis_pb';
import { AssessmentEnum } from '@protos/learning_management/lms.db_pb';
import { SubjectList } from '@protos/user_management/ums.login.apis_pb';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface IAssessmentTypes {
  name: string;
  id: AssessmentEnum;
}
export interface IReportState {
  reportsData: StudentAssessmentReportData | undefined;
  setectedSubject: SubjectList | undefined;
  searchByAssessType: IAssessmentTypes | undefined;
  pageNumber: number;
}

const initialState: IReportState = {
  reportsData: undefined,
  setectedSubject: undefined,
  searchByAssessType: undefined,
  pageNumber: 1,
};

export const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    setReportsData: (
      state,
      action: PayloadAction<StudentAssessmentReportData>
    ) => {
      state.reportsData = action.payload;
    },
    setSelectedSubject: (
      state,
      action: PayloadAction<SubjectList | undefined>
    ) => {
      state.setectedSubject = action.payload;
    },
    setSearchByAssessType: (
      state,
      action: PayloadAction<IAssessmentTypes | undefined>
    ) => {
      state.searchByAssessType = action.payload;
    },
    setPageNumber: (state, action: PayloadAction<number>) => {
      state.pageNumber = action.payload;
    },
    resetReportData: (state) => {
      return initialState;
    },
    // resetReportsData: (state) => {
    //   state.reportsData = undefined;
    // },
  },
});

export const {
  setReportsData,
  setSelectedSubject,
  setSearchByAssessType,
  setPageNumber,
  resetReportData,
} = reportSlice.actions;

export default reportSlice.reducer;
